import React from 'react';

import axios from 'axios';

import Modal from 'react-bootstrap/Modal';
import './quote.css';
import './propossal.css';
import thanks from '../../images/thank-you.png'

class Input extends React.Component {
    render() {
        return (
            <div className="form-group mb-5">

                <label className="block text-purple text-14 md:text-18">{this.props.label}</label>

                <input id={this.props.id}
                       className={(this.props.bg || 'bg-gray-light md:bg-white') + " w-full rounded-5 pl-15 py-5"}
                       onChange={(e) => this.props.onChange(this.props.name, e.target.value)}
                       type={this.props.type ? this.props.type : 'text'} name={this.props.name}
                       required={this.props.required} placeholder={this.props.placeholder}></input>
            </div>
        )
    }
}

class Propossal extends React.Component {
    constructor(props) {
        super(props);

        //this.hideModal = this.hideModal.bind(this);

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {

            formdata: {},
            showThanks: false,
            loadedThanks: false,
            title: props.ti,
            titleService: null, show: props.show,
            nda:'No',
            services:[],
        }


        this.handleChange = this.handleChange.bind(this);

        this.hideThanksModal = this.hideThanksModal.bind(this);
    }


    hideModal = () => {
        this.setState({showModal: false, titleService: null, showThanks: false, loadedThanks: false});
        this.props.hide()


    }


    handleChange = (param, value) => {
        if(param == 'nda'){
            this.setState({nda:value})
        }
        if (param == "service") {
            let checkboxes = document.getElementsByName('service');
            let checkboxesChecked = [];

            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    checkboxesChecked.push(checkboxes[i].value);
                }
            }
            if (checkboxesChecked.length > 1) {
                this.setState({titleService: "Digital Services",services:checkboxesChecked.join(',')})
            } else {
                this.setState({titleService: null})

            }

        }
        this.setState(prevState => {
            let formdata = Object.assign({}, prevState.formdata);
            formdata[param] = value;
            return {formdata};
        })
    }

    hideThanksModal() {
        this.hide()
        document.body.style.overflow = 'auto';

        document.body.style.overflowX = 'hidden';
    }

    onSubmit(e) {

        e.preventDefault();

        var that = this;

        var form_data = new FormData(e.target);
        for (var key in this.state.formdata) {
            form_data.append(key, this.state.formdata[key]);
        }
        if (this.state.titleService) form_data.append('title', this.state.titleService)
        else form_data.append('title', this.state.formdata.service)

        form_data.append('service',this.state.services)
        form_data.append('country', this.props.country);


        that.setState({showThanks: true});

        document.body.style.overflow = 'hidden';


        axios.post("https://mailer.weprodigi.com/api/v1/video-production", form_data).then(response => {

            that.setState({loadedThanks: true,services:[]});

        });
        e.target.reset()
    }

    render() {

        return (
            <Modal size="lg" show={this.props.show} onHide={this.hideModal} centered
                   className="proposal-modal quote-modal">

                <span className="hide" onClick={this.hideModal}>X</span>

                <Modal.Body>
                    {!this.state.showThanks ? <div>
                            <span className="title">Get a Proposal</span>
                            <form id="offer-form" method="POST" onSubmit={(e) => this.onSubmit(e)}>
                                <div className="">
                                    <style jsx global>{`
                                        .modal-body{
                                            padding: 20px 45px!important;
                                        }
                                        textarea::placeholder {
                                             font-size:14px;
                                             font-family: 'Montserrat';
                                          }
                                    `}</style>
                                    <div className="mb-10 row ">

                                        <p className="m-0-important col-sm-12-important numeric-item text-left text-purple font-medium mb-10">1.
                                            Which services are you more interested in?</p>
                                        <div classname="col-sm-12">
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="row">
                                                        <label
                                                            className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                                                            <input className="absolute cursor-pointer opacity-0"
                                                                   onChange={() => this.handleChange('service', 'Video Production')}
                                                                   type="checkbox" name="service"
                                                                   value="Video Production"></input>
                                                            <span
                                                                className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                            Video Production
                                                        </label>

                                                        <label
                                                            className="relative  col-md-12 pl-30  mt-10 cursor-pointer text-14 flex items-center">
                                                            <input className="absolute cursor-pointer opacity-0"
                                                                   onChange={() => this.handleChange('service', 'Social Media Marketing')}
                                                                   type="checkbox" name="service"
                                                                   value="Social Media Marketing"/>
                                                            <span
                                                                className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                            Social Media Marketing
                                                        </label>
                                                        
                                                    </div>


                                                </div>
                                                <div className="col-4">
                                                    <div className="row">

                                                      
                                                        <label
                                                            className="relative  col-md-12 pl-30  mt-10 cursor-pointer text-14 flex items-center">
                                                            <input className="absolute cursor-pointer opacity-0"
                                                                   onChange={() => this.handleChange('service', 'Development')}
                                                                   type="checkbox" name="service"
                                                                   value="Website Development"/>
                                                            <span
                                                                className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                            Website Development
                                                        </label>
                                                        <label
                                                            className="relative  col-md-12 pl-30 mt-10 cursor-pointer text-14 flex items-center">
                                                            <input className="absolute cursor-pointer opacity-0"
                                                                   onChange={() => this.handleChange('service', 'Paid Advertisement')}
                                                                   type="checkbox" name="service"
                                                                   value="Paid Advertising Services"/>
                                                            <span
                                                                className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                            Paid Advertising Services
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                <label
                                                            className="relative  col-md-12 pl-30 mt-10 cursor-pointer text-14 flex items-center">
                                                            <input className="absolute cursor-pointer opacity-0"
                                                                   onChange={() => this.handleChange('service', 'SEO')}
                                                                   type="checkbox" name="service" value="SEO"/>
                                                            <span
                                                                className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                            SEO
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="col-sm-12 text-left  m-0-important mt-2 ml-5 text-14 text-black mb-5 mt-10">Does
                                            your company have a website?*
                                        </div>
                                        <div className="col-sm-12 mt-10 flex flex-row my-10  ">

                                            <div className=" mr-30">
                                                <label className="relative   cursor-pointer text-14 flex items-center">
                                                    <input className="absolute cursor-pointer opacity-0"
                                                           onChange={() => this.handleChange('has-website', 'Yes')}
                                                           type="radio" name="has-website" value="Yes"/>
                                                    <span
                                                        className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                    Yes
                                                </label>
                                            </div>

                                            <div className=" mr-30">
                                                <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                                                    <input className="absolute cursor-pointer opacity-0"
                                                           onChange={() => this.handleChange('has-website', 'No')}
                                                           type="radio" name="has-website" value="No"/>
                                                    <span
                                                        className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                    No
                                                </label>
                                            </div>

                                        </div>
                                        {this.state.formdata['has-website'] == 'Yes' &&

                                        <div className="col-sm-12 m mt-10">
                                            <div className="form-group">
                                                <label>Website URL*</label>
                                                <input type="text" name="website" bg="bg-white" required={true}
                                                       onChange={this.handleChange} className="form-control"/>
                                            </div>
                                        </div>

                                        }
                                        <p className="m-0-important col-sm-12-important mt-10 numeric-item text-left text-purple font-medium mb-10"> 2.
                                            Is there anything specific we should know about your project?</p>
                                        <div className="col-sm-12 m mt-10">
                                            <div className="form-group">
                                                <textarea type="text" className="mt-0" name="description" placeholder="Background, requirements, budget, deadline, etc."
                                                          resize="resize-none	" bg="bg-gray-light" required={false}
                                                          rows={2}  onChange={this.handleChange}></textarea>

                                            </div>
                                        </div>


                                        <p className="m-0-important col-sm-12-important mt-10 numeric-item text-left text-purple font-medium mb-10"> 3.
                                            Tell us how to contact you</p>
                                        <div className="col-sm-12 m ">
                                            <div className="row">
                                                <div className="col-sm-12 m mt-10">

                                                    <div className="form-group">
                                                        <label>Name*</label>
                                                        <input type="text" name="name" bg="bg-gray-light" required={true}
                                                               className="form-control"
                                                               onChange={this.handleChange}></input>

                                                    </div>

                                                </div>
                                                <div className="col-6 m mt-10">
                                                    <div className="form-group">
                                                        <label>Email*</label>
                                                        <input type="text" name="email" bg="bg-gray-light" required={true}
                                                               onChange={this.handleChange}
                                                               className="form-control"></input>

                                                    </div>
                                                </div>
                                                <div className="col-6 m mt-10">

                                                    <div className="form-group">
                                                        <label>Number</label>
                                                        <input type="text" name="number" bg="bg-gray-light" required={false}
                                                               onChange={this.handleChange}
                                                               className="form-control"></input>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="row">
                                                    <div
                                                className="col-sm-12 text-left  m-0-important mt-2 ml-5 text-14 text-black mb-5 mt-10">What’s
                                                the best way to contact you?
                                            </div>
                                            <div className="col-sm-12 mt-10 flex flex-row my-10  ">

                                                <div className=" mr-30">
                                                    <label className="relative cursor-pointer text-14 flex items-center">
                                                        <input className="absolute cursor-pointer opacity-0"
                                                            onChange={() => this.handleChange('contact-via', 'Email')}
                                                            type="radio" name="contact-via" value="Email"></input>
                                                        <span
                                                            className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                                                        Email
                                                    </label>
                                                </div>

                                                <div className=" mr-30">
                                                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                                                        <input className="absolute cursor-pointer opacity-0"
                                                            onChange={() => this.handleChange('contact-via', 'Phone')}
                                                            type="radio" name="contact-via" value="Phone"></input>
                                                        <span
                                                            className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                                                        Phone
                                                    </label>
                                                </div>
                                                <div className=" mr-30">
                                                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                                                        <input className="absolute cursor-pointer opacity-0"
                                                            onChange={() => this.handleChange('contact-via', 'Both')}
                                                            type="radio" name="contact-via" value="Both"></input>
                                                        <span
                                                            className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                                                        Both
                                                    </label>
                                                </div>
                                            </div>
                                                    </div>
                                                </div>    
                                                <div className="col-6">
                                                    <div className="row">
                                                    <div className="col-sm-12 text-left  m-0-important mt-2 ml-5 text-14 text-black mb-5 mt-10">NDA needed</div>
                                            <div className="col-sm-12 mt-10 flex flex-row my-10  ">

                                                <div className=" mr-30">
                                                    <label className="relative cursor-pointer text-14 flex items-center">
                                                        <input className="absolute cursor-pointer opacity-0"
                                                            onChange={() => { if (this.state.nda == 'No') this.handleChange('nda', 'Yes'); else this.handleChange('nda', 'No')}}
                                                            type="checkbox" name="nda"/>
                                                        <span
                                                            className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"/>
                                                        Yes
                                                    </label>
                                                </div>

                                                 

                                            </div>

                                                    </div>    
                                                </div>    
                                            </div>
                                     </div>


                                    </div>
                                    <div className="form-group mt-10">

                                        <button id="quote-submit" type="submit" className="button">Submit</button>

                                    </div>
                                </div>
                            </form>

                        </div>
                        : (<>

                            {this.state.loadedThanks ?

                                <>

                                    <div className="text-center">
                                        <img
                                            src={thanks}
                                            width={259}
                                            height={220}
                                        />
                                    </div>

                                    <div className="text-black text-16 md:text-18 text-center">
                                        Thank you for reaching out to us! One of our account managers will contact you
                                        and confirm your request. If you don’t receive an email from us within 24 hours
                                        please check your Spam Box.

                                    </div>

                                    <p className="text-purple uppercase text-36 md:text-48 text-center font-black">Thank
                                        you</p>

                                    <a href="https://weprodigi.com"
                                       className="inline-block text-white bg-green rounded-5 text-16 md:text-18 py-9 px-30 mt-23">Back
                                        Home</a>

                                </>

                                :
                                <p className="text-black text-center">Loading...</p>
                            }

                        </>)
                    }


                </Modal.Body>
            </Modal>
        );
    }
}

export default Propossal;